export default __webpack_public_path__ + "static/media/hht1_ep12_timeline_q05_b.19eaf8b6.png";